import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import stylesheet, { backgroundColor } from 'src/constants/stylesheet';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import classNames from 'classnames';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
        },
        hr: {
            ...stylesheet.HR
        },
        textContainer: {
            position: 'relative',
            backgroundColor,
            [mediaQueries.Mobile]: {
                padding: spacing.Gutter.Mobile * 2,
            },
            [mediaQueries.Tablet]: {
                padding: spacing.Gutter.Tablet * 2,
            },
            [mediaQueries.Laptop]: {
                padding: spacing.Gutter.Laptop * 2,
            },
            [mediaQueries.Desktop]: {
                padding: spacing.Gutter.Desktop * 2,
            },

            '&$noLine': {
                [mediaQueries.Mobile]: {
                    padding: spacing.Gutter.Mobile,
                },
                [mediaQueries.Tablet]: {
                    padding: spacing.Gutter.Tablet,
                },
                [mediaQueries.Laptop]: {
                    padding: spacing.Gutter.Laptop,
                },
                [mediaQueries.Desktop]: {
                    padding: spacing.Gutter.Desktop,
                },
            }
        },
        noLine: {},
        text: {
            '& ul': {
                listStyle: 'initial',
                paddingLeft: '1em'
            }
        },
        caption: {
            position: 'absolute',
            bottom: 5,
            right: 10,
            fontSize: '.8rem'
        },
    }));

export type PanelInfoBoxProps = PanelInfoBoxDto;
type Props = PanelInfoBoxProps;

const PanelInfoBox: FC<Props> = ({ Text, Caption, ShowTopLine }) => {
    const cls = useStyles();

    return (
        <div className={cls.root}>
            {ShowTopLine &&
                <hr className={cls.hr} />
            }
            <div className={classNames(cls.textContainer, !ShowTopLine && cls.noLine)}>
                <div className={cls.text} dangerouslySetInnerHTML={{ __html: Text }} />
                <div className={cls.caption}>{Caption}</div>
            </div>
        </div>
    );
}

export default PanelInfoBox;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelInfoBox.tsx